import React from 'react';
import { Loading } from '../utils/Loading';
import { useMixpanelIsConnected } from './hooks/useMixpanelIsConnected';
import { MixpanelOverview } from './views/MixpanelOverview';
import { UserServiceModel } from '../../settings/users/types';

type Props = {
  tenant: number;
  hasAccessToConfiguration: boolean;
  user: UserServiceModel;
};

export function MixpanelIntegration({
  tenant,
  hasAccessToConfiguration,
  user,
}: Props) {
  const { isLoading } = useMixpanelIsConnected(tenant);

  return (
    <div className="row ml-4">
      <div className="tab-content w-100" id="TabContent">
        <div className="tab-pane fade active show" role="tabpanel">
          <div className="row justify-content-center">
            <div className="col-8 mt-4 mb-4">
              <div className="card box-shadow-3d mt-md-2 d-flex w-100">
                <div className="card-header">
                  <div className="d-flex align-items-center">
                    <img
                      className="con-map-mk-integration-logo-size"
                      style={{ width: '30px' }}
                      src="/media/integrations/logos/mixpanel-icon.png"
                    />
                    <h5 className="mb-0 ml-3">Mixpanel</h5>
                  </div>
                </div>

                <div className="card-body">
                  {isLoading && (
                    <Loading loadingLabel="Checking Mixpanel connection" />
                  )}
                  {!isLoading && (
                    <MixpanelOverview
                      tenant={tenant}
                      hasAccessToConfiguration={hasAccessToConfiguration}
                      user={user}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
